import app from 'flarum/common/app';
import MobileTabComponent from '../../common/components/MobileTabComponent';
import MobileTabItem from './MobileTabItem';
export default class ForumNotificationsTabItem extends MobileTabComponent {
  view() {
    if (!app.session.user) return;
    const unread = app.session.user.unreadNotificationCount();
    const _this$attrs$definitio = this.attrs.definition,
      icon = _this$attrs$definitio.icon,
      label = _this$attrs$definitio.label;
    return m(MobileTabItem, {
      href: app.route('notifications'),
      icon: icon
    }, unread ? m("span", {
      className: "Bubble"
    }, unread) : '', label);
  }
}
flarum.reg.add('acpl-mobile-tab', 'forum/components/ForumNotificationsTabItem', ForumNotificationsTabItem);